import { computed, ref } from "vue";
import { useStore } from "vuex";
import { Site } from "@/types/site.ts";

export type SiteSwitcherSite = Pick<
  Site,
  "_id" | "title" | "styleName" | "primaryLogo" | "siteID"
>;

export default function useSiteSwitcher() {
  const store = useStore();

  const isInternal = computed(() => store.getters.getIsInternal);

  const sites = computed(() => store.getters["api/siteSwitcherSites"]());

  const isInternalSiteSearchLoading = ref(false);

  const currentSite = computed(() =>
    sites.value.find(
      (site: SiteSwitcherSite) => site.siteID === store.getters.getStyleID
    )
  );

  const filteredSites = computed(() =>
    sites.value.filter(
      (site: SiteSwitcherSite) => site.siteID !== store.getters.getStyleID
    )
  );

  const currentSiteLogoUrl = computed(() =>
    currentSite.value && currentSite.value?.primaryLogo?.[0]?.uuid
      ? `https://media.rocketalumnisolutions.com/${currentSite.value?.primaryLogo?.[0]?.uuid}/-/resize/100x/`
      : undefined
  );

  function goToSite(site: SiteSwitcherSite) {
    const isHttps = document.location.protocol === "https:";
    document.location.href = `${isHttps ? "https" : "http"}://${
      document.location.host
    }/home/${site.siteID}`;
  }

  async function searchSiteName(name: string) {
    isInternalSiteSearchLoading.value = true;
    await store.dispatch("api/searchSiteSwitcherSites", name);
    isInternalSiteSearchLoading.value = false;
  }

  return {
    sites,
    filteredSites,
    currentSite,
    currentSiteLogoUrl,
    goToSite,
    isInternal,
    searchSiteName,
    isInternalSiteSearchLoading,
  };
}
